export interface Products {
  id: string;
  title: string;
  subject: string;
  desc: string;
  location: string;
  duration: number;
  images: string[];
  product: unknown[];
}

export async function getProducts() {
  const response = await fetch(`/api/products`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Error fetching product info: ${response.statusText}`);
  }

  const data = await response.json();
  return data.data; // matches backend: { success: true, data: contact }
}
